import "./index.css";
import "normalize.css";
import "@hubper/theme/fonts/fonts.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { BrowserRouter } from "react-router-dom";
import { init } from "./api/instance";

import {
  ZIndexManager,
  ModalManager,
  LayerManager,
  NotifyManager
} from "@hubper/core-ui/managers";

import { UserProvider } from "./UserProvider";

init(
  process.env.REACT_APP_API_BASE ||
    window.localStorage.getItem("API_BASE_TRANSLATION") ||
    "/api"
);

ReactDOM.render(
  <ZIndexManager>
    <LayerManager>
      <ModalManager>
        <NotifyManager>
          <BrowserRouter>
            <UserProvider>
              <App />
            </UserProvider>
          </BrowserRouter>
        </NotifyManager>
      </ModalManager>
    </LayerManager>
  </ZIndexManager>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
